<template>
  <div>
    <h1 class="text-center font-extrabold text-xl">Modification du profil</h1>
    <Loading v-if="loading" />
    <MerchantProfileForm
      v-else
      v-model="merchantProfile"
      :organizationId="merchantProfile.organizationId"
      @submit="submit"
    />
  </div>
</template>

<script>
import MerchantProfileForm from "@/components/merchant_profiles/MerchantProfileForm.vue";
import { Loading } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    Loading,
    MerchantProfileForm,
  },
  props: {
    merchantProfileId: {
      type: Number,
      required: true,
    },
  },
  emits: ["success"],
  data() {
    return {
      loading: true,
      merchantProfile: {},
    };
  },
  async mounted() {
    this.merchantProfile = await this.fetch({ id: this.merchantProfileId, includes: ["store_ids"] });
    this.loading = false;
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("merchantProfiles", ["fetch", "update"]),

    async submit() {
      const result = await this.update({ id: this.merchantProfile.id, params: this.merchantProfile });
      if (!result) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Profil mis à jour",
      });

      this.$emit("success");
    },
  },
};
</script>
